
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/media-page",
      function () {
        return require("private-next-pages/media-page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/media-page"])
      });
    }
  